var React = require('react');

function BandcampInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Bandcamp icon"),React.createElement("path",{"d":"M0 18.75l7.437-13.5H24l-7.438 13.5H0z","key":1})]);
}

BandcampInline.defaultProps = {"role":"img","viewBox":"0 0 24 24"};

module.exports = BandcampInline;

BandcampInline.default = BandcampInline;
